import React from 'react';

const UnderConstruction = ({imageInsert}) => (
  <div className="working-in-progress">Case study in progress</div>
)

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/layout/portfolio/UnderConstruction.js